import { NavigationContext } from '@/shared/NavigationContext/NavigationContext';
import { useContext } from 'react';

export default function useSearchThemes() {
  const navigationContext = useContext(NavigationContext);

  const actions = {
    setSearchText: (e) => {
      navigationContext.actions.setPageData('themes', {
        ...navigationContext.state.pagesData.themes,
        searchText: e.target?.value,
      });
    },
    setActivityType: (activityType) => {
      navigationContext.actions.setPageData('themes', {
        ...navigationContext.state.pagesData.themes,
        activityType,
      });
    },
  };

  return {
    state: {
      ...navigationContext.state.pagesData.themes,
    },
    actions,
  };
}
